import { lazy, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import SpinLoader from './components/layouts/SpinLoader';
import Level1 from "./components/pages/Level1";
import Level2 from "./components/pages/Level2";
import Level3 from "./components/pages/Level3";
import Results from "./components/pages/result";
import { ImageProvider } from './components/ImageContext';
const Home = lazy(() => import('./components/pages/Home'));

function App() {
    return (
        <>
            <ToastContainer />
            <BrowserRouter>
                <Suspense fallback={<SpinLoader />} >
                    <ImageProvider>
                        <Routes>
                            <Route path="/" element={<Home />}>
                                <Route index element={<Home />} />
                            </Route>
                            <Route path="/level-1" element={<Level1 />} />
                            <Route path="/level-2" element={<Level2 />} />
                            <Route path="/level-3" element={<Level3 />} />
                            <Route path="/result" element={<Results />} />
                        </Routes>
                    </ImageProvider>
                </Suspense>
            </BrowserRouter>

        </>

    );
}

export default App;
